/** Minimal placeholder while a lazy route chunk loads — no spinner animation. */
export function RouteFallback() {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center px-4" role="status" aria-live="polite">
      <div className="h-1 w-24 overflow-hidden rounded-full bg-white/[0.06]">
        <div className="h-full w-1/2 animate-pulse rounded-full bg-kavach-cyan/50" />
      </div>
      <span className="mt-3 text-xs text-slate-500">Loading page…</span>
    </div>
  )
}
